var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfoLeftLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C15.2467 0.5 19.5 4.75329 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.75329 19.5 0.5 15.2467 0.5 10C0.5 4.75329 4.75329 0.5 10 0.5Z",
    fill: "white",
    stroke: "#00494F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89258 6.08691C8.89258 5.78613 8.9974 5.53092 9.20703 5.32129C9.42122 5.1071 9.67871 5 9.97949 5C10.2757 5 10.5286 5.1071 10.7383 5.32129C10.9525 5.53092 11.0596 5.78613 11.0596 6.08691C11.0596 6.3877 10.9525 6.64518 10.7383 6.85938C10.5286 7.06901 10.2757 7.17383 9.97949 7.17383C9.67871 7.17383 9.42122 7.06901 9.20703 6.85938C8.9974 6.64518 8.89258 6.3877 8.89258 6.08691ZM8.27734 14.3379C8.52344 14.2969 8.69206 14.2354 8.7832 14.1533C8.91992 14.0303 8.98828 13.8092 8.98828 13.4902V9.375C8.98828 9.09245 8.94043 8.90104 8.84473 8.80078C8.74902 8.69596 8.5599 8.61849 8.27734 8.56836V8.22656H10.9639V13.5449C10.9639 13.8503 11.0094 14.0462 11.1006 14.1328C11.1917 14.2194 11.3626 14.2878 11.6133 14.3379V14.6729H8.27734V14.3379Z",
    fill: "#00494F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoLeftLine);
export default __webpack_public_path__ + "static/media/Icon-Info-Left-Line.ac328e08.svg";
export { ForwardRef as ReactComponent };